<template>
  <div class="content-shopcart">
    <div class="content-shopcart-items container">
      <div class="content-shopcart-items-left">
        <button class="content-shopcart-items-left-btn" @click="setActiveCategory(true)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19.071" viewBox="0 0 24 19.071">
            <path id="Caminho_2762" data-name="Caminho 2762"
              d="M23.679,79.929H.321A.321.321,0,0,1,0,79.607V78.321A.321.321,0,0,1,.321,78H23.679a.321.321,0,0,1,.321.321v1.286a.321.321,0,0,1-.321.321Zm0,8.571H.321A.321.321,0,0,1,0,88.179V86.893a.321.321,0,0,1,.321-.321H23.679a.321.321,0,0,1,.321.321v1.286a.321.321,0,0,1-.321.321Zm-4.322,8.571H.321A.321.321,0,0,1,0,96.75V95.464a.321.321,0,0,1,.321-.321H19.357a.321.321,0,0,1,.321.321V96.75a.321.321,0,0,1-.321.321Z"
              transform="translate(0 -78)" fill="#fff" />
          </svg>
          <p>{{ $t('pages.product.categories') }}</p>
        </button>
        <h3 class="content-shopcart-items-left-text">
          {{ store.name }}
        </h3>
      </div>
      <div class="content-shopcart-items-right">
        <div class="content-shopcart-items-right-text">
          <p>{{ $t('pages.product.yourcart') }}</p>
          <h4>{{ product.total_price | money }}</h4>
        </div>
        <button @click="setActiveCart(true)" class="content-shopcart-items-right-btn">
          {{ $t('pages.product.view') }}
          <svg xmlns="http://www.w3.org/2000/svg" width="28.066" height="24.947" viewBox="0 0 28.066 24.947">
            <path id="Caminho_2763" data-name="Caminho 2763"
              d="M26.9,3.118H6.3L5.893.954A1.169,1.169,0,0,0,4.744,0H.585A.585.585,0,0,0,0,.585v.39a.585.585,0,0,0,.585.585H4.42L7.828,19.731a3.119,3.119,0,1,0,5.007.539h7.073a3.118,3.118,0,1,0,4.874-.676,1.17,1.17,0,0,0-1.135-.883H9.223l-.585-3.118H24.784a1.169,1.169,0,0,0,1.145-.931L28.041,4.526A1.169,1.169,0,0,0,26.9,3.118Z"
              fill="var( --green-medium)" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      name: [],
    };
  },
  props: ["store"],
  computed: {
    ...mapGetters(["activeCart"]),
    ...mapGetters(["activeCategory"]),
    ...mapGetters({
      product: "Cart/cart",
    }),
  },
  methods: {
    ...mapActions(["setActiveCart"]),
    ...mapActions(["setActiveCategory"]),
  },
};
</script>
<style lang="scss" scoped>
.content-shopcart {
  width: 100%;
  height: 130px;
  position: fixed;
  top: 70px;
  background-color: #f2f2f2;
  z-index: 999;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

  @media screen and (max-width: 991px) {
    height: auto;
    top: 62px;
    padding: 25px 20px;
  }

  &-items {
    display: flex;
    justify-content: space-between;
    height: 100%;
    align-items: center;

    @media screen and (max-width: 991px) {
      max-width: 100%;
      padding: 0;
      align-items: flex-end;
    }

    &-left {
      display: flex;
      align-items: center;
      width: calc(100% - 270px);

      @media screen and (max-width: 991px) {
        flex-direction: column-reverse;
        align-items: flex-start;
        width: 100%;
      }

      &-btn {
        width: 203px;
        height: 60px;
        margin-right: 30px;
        border: none;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--green-medium);
        color: var(--white);
        border-radius: 10px;
        transition: 500ms;

        @media screen and (max-width: 991px) {
          width: 172px;
          margin-right: 0;
          margin-top: 15px;
        }

        @media (max-width: 359px) {
          width: 150px;
        }

        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }

        svg {
          margin-right: 10px;
        }

        P {
          font-family: "Font Regular";
          font-size: 22px;
          color: var(--white);
          margin: 0;

          @media screen and (max-width: 991px) {
            font-size: 18px;
          }
        }
      }

      &-text {
        font-family: "Font Regular";
        font-size: 30px;
        color: var(--green-dark);
        margin: 0;
        padding: 0;
        text-align: left;
        width: calc(100% - 233px);

        @media (max-width: 991px) {
          font-size: 22px;
          height: 52px;
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }

    &-right {
      display: flex;
      align-items: center;
      height: 60px;

      &-text {
        display: flex;
        flex-direction: column;
        text-align: end;
        margin-right: 2rem;

        @media screen and (max-width: 991px) {
          display: none;
        }

        p {
          font-family: "Font Regular";
          font-size: 18px;
          color: var(--green-dark);
          padding: 0;
          margin: 0 0 0.2rem 0;

          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
          }

          @media screen and (max-width: 576px) {
            display: none;
          }
        }

        h4 {
          font-family: "Font Bold";
          font-size: 24px;
          color: var(--green-medium);
          padding: 0;
          margin: 0;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }

          @media screen and (max-width: 350px) {
            font-size: 0.8rem;
          }
        }
      }

      &-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 113px;
        height: 60px;
        border: 1px solid var(--green-medium);
        background-color: #ffffff;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
        border-radius: 10px;
        color: var(--green-medium);
        font-family: "Font Regular";
        font-size: 22px;
        transition: 500ms;

        @media (max-width: 991px) {
          position: absolute;
          right: 20px;
          font-size: 18px;
        }

        &:hover,
        &:focus {
          cursor: pointer;
          opacity: 0.8;
        }

        svg {
          margin-left: 10px;

          @media (max-width: 991px) {
            margin-left: 15px;
          }
        }
      }
    }
  }
}</style>
